export default __webpack_public_path__ + "static/media/bp-bol-new.6898eed3.png";